import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import ParticlesAuth from "../ParticlesAuth";
import { useLocation } from "react-router-dom";
//import images
import logoLight from "../../../assets/images/logo-light.svg";

/**
 * React component for handling user logout.
 * @component
 */
const BasicLogout = () => {
	const location = useLocation();
	const navigate = useNavigate();
	useEffect(() => {
		if (location.state === null) {
			navigate("/login");
		}
	});
	document.title = "Log Out | Adcropper";
	return (
		<React.Fragment>
			<ParticlesAuth>
				<div className="auth-page-content mt-lg-5 mt-xs-5">
					<Container>
						<Row>
							<Col lg={12}>
								<div className="text-center mt-sm-5 mb-4 text-white-50">
									<div>
										<Link to="/dashboard" className="d-inline-block auth-logo">
											<img src={logoLight} alt="" height="40" />
										</Link>
									</div>
								</div>
							</Col>
						</Row>

						<Row className="justify-content-center">
							<Col md={8} lg={6} xl={5}>
								<Card className="mt-4">
									<CardBody className="p-4 text-center">
										<lord-icon
											src="https://cdn.lordicon.com/hzomhqxz.json"
											trigger="loop"
											colors="primary:#405189,secondary:#08a88a"
											style={{ width: "180px", height: "180px" }}>
										</lord-icon>

										<div className="mt-4 pt-2">
											<h5>You are Logged Out</h5>
											<p className="text-muted">Thank you for using Adcropper.</p>
											<div className="mt-4">
												<Link to="/login" className="btn btn-success w-100">Sign In</Link>
											</div>
										</div>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</ParticlesAuth>
		</React.Fragment >
	);
};

export default BasicLogout;